import { Confirm, Icon, UserAvatar } from 'components'
import { Reorder } from 'framer-motion'
import {
  Edit,
  DragHandle,
  Details,
  Songs,
  SongData,
  Title,
  Song,
  Actions,
} from './styles'

const SongItem = ({ item, canDelete, onDelete, showDragHandle }) => {
  const { id, details: { song, user } } = item

  return (
    <>
      {showDragHandle && (
        <DragHandle>
          <Icon icon="drag-horizontal-variant" />
        </DragHandle>
      )}
      <SongData>
        <UserAvatar user={user} />
        <Details>
          <Title>{user.full_name || user.email}</Title>
          <Title>{song.title}</Title>
        </Details>
      </SongData>
      <Actions>
        {canDelete(user) && (
          <Confirm
            handler={(yes) => onDelete(yes, id)}
            message={`Remove "${song.title}" from the queue?`}
          >
            <Edit>
              <Icon icon="trash-can" />
            </Edit>
          </Confirm>
        )}
      </Actions>
    </>
  )
}

export const SongList = ({ songs = [], size = 'md', actor, onDelete, isHost, onReorder }) => {
  const canDelete = (user) => {
    if (!onDelete) return false
    if (isHost) return true
    if (actor?.id && actor.id === user?.id) return true
    if (!actor?.id && actor?.full_name && actor.full_name === user?.full_name) return true
    return false
  }

  if (isHost && onReorder && songs.length > 0) {
    return (
      <Reorder.Group
        axis="y"
        values={songs}
        onReorder={onReorder}
        as="ul"
        style={{ listStyle: 'none', margin: 0, padding: 0 }}
      >
        {songs.map((item) => (
          <Reorder.Item
            key={item.id}
            value={item}
            as="li"
            style={{
              margin: '0.5rem',
              padding: '0.5rem',
              borderRadius: '0.5rem',
              background: '#333',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              cursor: 'grab'
            }}
            whileDrag={{
              scale: 1.02,
              boxShadow: '0 5px 15px rgba(0,0,0,0.3)',
              cursor: 'grabbing'
            }}
          >
            <SongItem
              item={item}
              canDelete={canDelete}
              onDelete={onDelete}
              showDragHandle={true}
            />
          </Reorder.Item>
        ))}
      </Reorder.Group>
    )
  }

  return (
    <Songs>
      {songs?.map((item) => (
        <Song key={item.id} className={item.state}>
          <SongItem item={item} canDelete={canDelete} onDelete={onDelete} showDragHandle={false} />
        </Song>
      ))}
    </Songs>
  )
}
